/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Legal_Entity_CreateInputs */

const cs_settings_office_legal_entity_create = /** @type {(inputs: Settings_Office_Legal_Entity_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořit právnickou osobu`)
};

const en_settings_office_legal_entity_create = /** @type {(inputs: Settings_Office_Legal_Entity_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create legal entity`)
};

/**
* | output |
* | --- |
* | "Create legal entity" |
*
* @param {Settings_Office_Legal_Entity_CreateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_legal_entity_create = /** @type {((inputs?: Settings_Office_Legal_Entity_CreateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Legal_Entity_CreateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_legal_entity_create(inputs)
	return cs_settings_office_legal_entity_create(inputs)
});